import {
  ControlOutlined,
  DownOutlined,
  PlusOutlined,
  SearchOutlined,
} from '@ant-design/icons';
import {
  Button,
  Checkbox,
  Col,
  DatePicker,
  Dropdown,
  Form,
  Input,
  Menu,
  Popover,
  Row,
  Select,
  Spin,
  Tag,
  Tooltip,
  TreeSelect,
} from 'antd';
import { GET_COMPANY_POWERBIV2, GET_IMPACTTYPE, GET_PROJECT_CATEGORY, GET_PROJECT_GROUP_V2, GET_PROJECT_IMPERATIVE } from 'api/Admin/powerbi';
import { getCompanyReport } from 'api/Dashboard/company_report';
import { getResultOperation } from 'api/MasterData/operation';
import { getResultSubOperation } from 'api/MasterData/subOperation';
import { getOptionProject } from 'api/projectList';
import Company from 'components/Management/Tree/PowerBI/company';
import TreeSelectOperation from 'components/Management/Tree/PowerBI/OperationTree';
import TreeSelectSubOperation from 'components/Management/Tree/PowerBI/SuboperationTree';
import { getCookie, removeCookie, setCookie } from 'helper/cookie';
import { get, isEmpty } from 'lodash';
import moment from 'moment';
import { useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { CounterContext } from 'redux/Golbalvalues';
import styled from 'styled-components';

const initalState = {
  data: [],
  isLoading: true,
}

const { RangePicker } = DatePicker
const HeaderContent = (props) => {
  const { permission, word, company_user, onDataReceived } = props
  const { mainRoleUser } = useContext(CounterContext)
  const { Option } = Select
  const { Search } = Input
  const token = getCookie('access_token_admin')
  const [isLoading, setIsLoading] = useState(initalState.isLoading)
  const [data, setData] = useState(initalState.data)
  const [dataOptionProject, setDataOptionProject] = useState(initalState.data)
  const [dataSearchURL, setDataSearchURL] = useState({
    start_date: '',
    end_date: '',
    company_id: '',
    operation_id: '',
    suboperation_id: '',
    project_group_id: '',
    subproject_group_id: '',
    impact_type_id: '',
    status_id: '',
  })
  const [visible, setVisible] = useState(false)
  const [onSortBy, setOnSortBy] = useState('1')

  const [onSortTopOrButtom, setOnSortTopOrButtom] = useState(true)
  const queryParam = new URLSearchParams(window.location.search)
  const [dateSearch, setDateSearch] = useState([])
  const [dataCompany, setDataCompany] = useState([])
  const [dataOperation, setDataOperation] = useState([])
  const [dataSubOperation, setDataSubOperation] = useState([])
  const [onSearch, setOnSearch] = useState(false)
  const [disable, setDisable] = useState({
    company: false,
    operation: true,
    suboperation: true,
    projectgroup: true,
    projectcat: true,
    impacttype: true,
  })
  const dataCookieFilter = getCookie('project_list_filter')
  const dataCookieToJson = eval('(' + dataCookieFilter + ')')

  const [statusDataListFromApi, setStatusDataListFromApi] = useState([])
  const [totalListStatusFromApi, setTotalListStatusFromApi] = useState(0)
  const [listStatusWhenCheang, setListStatusWhenCheang] = useState([])
  const [openTreeStatus, setOpenTreeStatus] = useState(false)

  const [masterData, setMasterData] = useState([])
  const [masterDataProjectGroup, setMasterDataProjectGroup] = useState([])
  const [masterDataProjectCategory, setMasterDataProjectCategory] = useState([])
  const [masterDataImperative, setMasterDataImperative] = useState([])
  const [masterDataImpactType, setMasterDataImpactType] = useState([])

  const [choiceCompany, setChoiceCompany] = useState([])
  const [choiceOperation, setChoiceOperation] = useState([])
  const [choiceSubOperation, setChoiceSubOperation] = useState([])
  const [choiceProjectCategory, setChoiceProjectCategory] = useState([])
  const [choiceProjectGroup, setChoiceProjectGroup] = useState([])
  const [choiceImpactType, setChoiceImpactType] = useState([])
  const [choiceImperative, setChoiceImperative] = useState([])
  const isMobielView = useSelector((state) => get(state, 'device.isMobileView', false))
  const [paramDelay, setParamDelay] = useState('n')
  const [isChecked, setIsChecked] = useState(false)

  const [type, setType] = useState(1)
  const [accountOptions, setAccountOptions] = useState([])
  const [isShowAdvanFilter, setIsShowAdvanFilter] = useState(false)

  useEffect(() => {
    if (isShowAdvanFilter) {
      setTimeout(() => {
        setIsShowAdvanFilter(false)
      }, 1000)
    }
  }, [isShowAdvanFilter])

  useEffect(() => {
    setDataSearchURL((prevState) => ({
      ...prevState,
      start_date: queryParam.get('start_date'),
      end_date: queryParam.get('end_date'),
      company_id: queryParam.get('company_id'),
      operation_id: queryParam.get('operation_id'),
      suboperation_id: queryParam.get('suboperation_id'),
      project_group_id: queryParam.get('project_group_id'),
      subproject_group_id: queryParam.get('subproject_group_id'),
      impact_type_id: queryParam.get('impact_type_id'),
      status_id: queryParam.get('status_id'),
      ondelay: form.getFieldValue('ondelay'),
    }))
  }, [window.location.search])

  const history = useHistory()

  const [form] = Form.useForm()
  const dataForAction = {
    project: form.getFieldValue('project'),
    status: form.getFieldValue('status'),
    company: form.getFieldValue('company'),
    date: form.getFieldValue('date'),
    impact_type: form.getFieldValue('impact_type'),
    project_cat: form.getFieldValue('project_cat'),
    project_group: form.getFieldValue('project_group'),
    sub_opearation: form.getFieldValue('sub_opearation'),
    operation: form.getFieldValue('operation'),
    ondelay: form.getFieldValue('ondelay'),
  }

  const Box = styled.div`
    width: fit-content;
    height: 100%;
    border: 0.5px solid #d9d9d9;
    // box-sizing: border-box;
    border-radius: 2px;
    display: flex;
    justify-content: center;
  `

  const getResultListCompanyBI = async () => {
    setIsShowAdvanFilter(true)
    await GET_COMPANY_POWERBIV2({
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (error) {
          return true
        }
        if (status === 200) {
          setMasterData(data)
        } else {
          return true
        }
      })
      .catch((error) => {
        console.error(error)
      })
  }

  const getResultCompany = async () => {
    setIsShowAdvanFilter(true)
    await getCompanyReport({
      pathURL: mainRoleUser !== '1' ? 'company/report' : 'company?level=1',
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (error) {
          return true
        }
        if (status === 200) {
          const mapping_DefaultData = data?.map((item) => {
            return {
              id: item.id,
              name_en: item.name_en,
              name_th: item.name_th,
            }
          })
          const groupArrayCompany = [
            // {
            //   id: 0,
            //   name_en: 'All Company',
            //   name_th: 'ทั้งหมด',
            // },
            ...mapping_DefaultData,
            // ...mapping_CompanyLink,
          ]
          let id = dataCookieToJson?.company
            ? dataCookieToJson?.company
            : groupArrayCompany[0]?.id

          setDataCompany(groupArrayCompany)
          getOperation(id)

          setDisable((prevState) => ({
            ...prevState,
          }))
          if (!dataCookieFilter) {
            form.setFieldsValue({ company: id })
          }
        } else {
          return true
        }
      })
      .catch((error) => {
        console.error(error)
      })
  }
  const getOperation = async (company_id) => {
    setIsShowAdvanFilter(true)
    await getResultOperation({
      token: token,
      level_id: company_id,
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (error) {
          setDataOperation([])
          return true
        }
        if (status === 200) {
          setDataOperation(data)
        } else {
          setDataOperation([])
          return true
        }
      })
      .catch((error) => {
        setDataOperation([])
        console.error(error)
      })
  }
  const getSubOperation = async (company_id) => {
    setIsShowAdvanFilter(true)
    await getResultSubOperation({
      token: token,
      level_id: company_id,
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (error) {
          await setDataSubOperation([])
          return true
        }
        if (status === 200) {
          await setDataSubOperation(data)
        } else {
          return true
        }
      })
      .catch((error) => {
        setDataSubOperation([])
        console.error(error)
      })
  }
  const getResultOptionProject = async () => {
    await getOptionProject({
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (error) {
          await setDataOptionProject([])
          await setIsLoading(false)
          return true
        }
        if (status === 200) {
          const configData = data.map((e, i) => {
            const dataObject = {
              title: e.name,
              label: e.name,
              value: e.id,
              key: `0-${i + 1}`,
            }
            return dataObject
          })

          const selectAll = [
            {
              title: 'All',
              label: 'All',
              value: 0,
              key: '0-0',
            },
            ...configData,
          ]
          setTotalListStatusFromApi(data.length)
          setStatusDataListFromApi(selectAll)
          await setDataOptionProject(data)
          await setIsLoading(false)
        } else {
          setDataOptionProject([])
          setIsLoading(false)
          return true
        }
      })
      .catch((error) => {
        setDataOptionProject([])
        setIsLoading(false)
        console.error(error)
      })
  }

  const goCreate = () => {
    setCookie('wordLine', '')
    localStorage.setItem('activeProjectTab', '2')
    history.push({
      pathname: '/create-project',
    })
  }

  useEffect(() => {
    const returnArray = (data) => {
      if (data === 0 || data === undefined) {
        return []
      } else {
        return data
      }
    }

    if (token) {
      setChoiceCompany(returnArray(dataCookieToJson?.company))
      setChoiceOperation(dataCookieToJson?.operation)
      setChoiceSubOperation(dataCookieToJson?.sub_opearation)

      setChoiceProjectGroup(returnArray(dataCookieToJson?.project_group))
      setChoiceProjectCategory(dataCookieToJson?.subproject_group_id)
      setChoiceImpactType(dataCookieToJson?.impact_type)

      getResultListCompanyBI()
      form.setFieldsValue({
        status:
          queryParam.get('status_id') == null
            ? null
            : parseInt(queryParam.get('status_id')),

        project:
          queryParam.get('searchvalue') == null ? null : queryParam.get('searchvalue'),
        ondelay: dataCookieToJson?.ondelay || 'n',
      })
      setIsChecked(dataCookieToJson?.ondelay === 'y')
      getResultCompany()
      getResultOptionProject()

      return () => {
        getResultOptionProject()
      }
    }
  }, [token])

  useEffect(() => {
    if (window.location.href.split('/')[3].includes('status_id')) {
      if (choiceCompany.length > 0) {
        setChoiceCompany([])
        setChoiceOperation([])
        setChoiceSubOperation([])
        setChoiceProjectCategory([])
        setChoiceProjectGroup([])
        setChoiceImpactType([])
      }
    }
  }, [])

  useEffect(() => {
    if (window.location.href.split('/')[3] == 'project-list') {
      if (dataCookieToJson?.status === 0) {
        form.setFieldsValue({
          status: dataCookieToJson?.status || undefined,
          project: dataCookieToJson?.project || null,
        })
      } else {
        if (dataCookieToJson?.status) {
          form.setFieldsValue({
            status:
              dataCookieToJson?.status?.split(',').map((str) => parseInt(str)) ||
              undefined,
            project: dataCookieToJson?.project || null,
          })
        } else {
          form.setFieldsValue({
            status: undefined,
            project: dataCookieToJson?.project || null,
          })
        }
      }
    }

    if (dataCookieFilter) {
      const dataStatus = String(dataCookieToJson?.status)
      if (dataStatus === 0) {
        const mapDataListStatusById = statusDataListFromApi.map((e) => e.value)
        setListStatusWhenCheang(mapDataListStatusById)
      } else {
        if (dataStatus) {
          setListStatusWhenCheang(
            dataStatus?.split(',').map((str) => parseInt(str)) || undefined,
          )
        } else {
          setListStatusWhenCheang(undefined)
        }
      }

      setOnSortBy(dataCookieToJson.dataSortByType)
      setOnSortTopOrButtom(dataCookieToJson.dataSortTopOrButtom)
      const filterOptions = {
        company: dataCookieToJson.company || undefined,
        operation: dataCookieToJson.operation || undefined,
        sub_operation: dataCookieToJson.sub_opearation || undefined,
        project_group: dataCookieToJson?.project_group || undefined,
        project_cat: dataCookieToJson?.project_cat || undefined,
      }
      Object.keys(filterOptions).forEach((key) => {
        onChangeSelect(filterOptions[key], key)
      })
      form.setFieldsValue({
        date:
          dataCookieToJson?.date === null || dataCookieToJson?.date === undefined
            ? null
            : [
              moment(dataCookieToJson?.date[0], 'YYYY-MM-DD'),
              moment(dataCookieToJson?.date[1], 'YYYY-MM-DD'),
            ],
        company: dataCookieToJson.company,
        operation: dataCookieToJson.operation,
        sub_opearation: dataCookieToJson.sub_opearation,
        project_group: dataCookieToJson?.project_group,
        project_cat: dataCookieToJson?.project_cat,
        impact_type: dataCookieToJson.impact_type,
      })
      // form.submit()
    }
  }, [window.location.href, isLoading])

  useEffect(() => {
    if (!token || !choiceCompany?.length) {
      setMasterDataProjectGroup([])
      setMasterDataImpactType([])
      return
    }
    GET_PROJECT_GROUP_V2(token, choiceCompany).then(({ data, error }) => {
      if (!error) setMasterDataProjectGroup(data || [])
    })
    GET_IMPACTTYPE(token, choiceCompany).then(({ data, error }) => {
      if (!error) setMasterDataImpactType(data || [])
    })
  }, [choiceCompany])

  useEffect(() => {
    if (!token || !choiceProjectGroup?.length) {
      setMasterDataProjectCategory([])
      setChoiceProjectCategory([])
      return
    }
    GET_PROJECT_CATEGORY(token, choiceCompany, choiceProjectGroup).then(({ data, error }) => {
      if (!error) setMasterDataProjectCategory(data || [])
    })
  }, [choiceProjectGroup])

  useEffect(() => {
    if (!token || !choiceProjectCategory?.length) {
      setMasterDataImperative([])
      setChoiceImperative([])
      return
    }
    GET_PROJECT_IMPERATIVE(token, choiceProjectCategory).then(({ data, error }) => {
      if (!error) setMasterDataImperative(data || [])
    })
  }, [choiceProjectCategory])

  const onFinish = (values) => {
    let dataSortTopOrButtom =
      values?.toTop !== undefined ? values?.toTop : onSortTopOrButtom
    let dataSortByType = values?.sortBy !== undefined ? values?.sortBy : onSortBy

    const dataStatus = values?.status?.includes(0)
      ? '0'
      : values?.status?.length > 0
        ? String(values.status)
        : ''

    const dataStatusToCookie =
      values?.status?.includes(0) || values?.status !== undefined
        ? String(values.status)
        : values?.status?.length > 0
          ? String(values.status)
          : ''

    let addOneDateCerenDate =
      dataCookieToJson?.date === undefined
        ? undefined
        : dataCookieToJson?.date === null
          ? undefined
          : dataCookieToJson?.date.map((date) => moment(date).format('YYYY-MM-DD'))
    let dataToValues =
      values?.date === undefined
        ? undefined
        : values?.date === null
          ? undefined
          : values?.date.map((date) => moment(date).format('YYYY-MM-DD'))

    const dateData = dataToValues || addOneDateCerenDate

    const dataToSearch = {
      ...values,
      date: dateData,
      status: dataStatus,
      company: choiceCompany,
      operation: choiceOperation,
      sub_opearation: choiceSubOperation,
      project_group_id: choiceProjectGroup,
      subproject_group_id: choiceProjectCategory,
      impact_type: choiceImpactType,
      imperative_ids: choiceImperative,
      dataSortTopOrButtom,
      dataSortByType,
      ondelay: values?.ondelay === 'n' ? 'n' : isEmpty(values?.ondelay) ? 'n' : 'y',
    }

    const dataToSaveCookie = {
      ...values,
      date: dateData,
      company: choiceCompany,
      operation: choiceOperation,
      sub_opearation: choiceSubOperation,
      status: dataStatusToCookie,
      project_group: choiceProjectGroup,
      subproject_group_id: choiceProjectCategory,
      impact_type: choiceImpactType,
      dataSortTopOrButtom,
      dataSortByType,
      ondelay: values?.ondelay === 'n' ? 'n' : isEmpty(values?.ondelay) ? 'n' : 'y',
    }

    setCookie('project_list_filter', dataToSaveCookie)
    setCookie('project_list_filter_For_api', dataToSearch)

    props.setDataSearch(dataToSearch)

    if (queryParam.get('status_id') != undefined) {
      let arr = []
      arr.push(window.location.href.split(`&`)[0])
      arr.push(window.location.href.split(`&`)[1])

      if (values.status == '' || values.status == undefined) {
      } else {
        arr.push(`status_id=${values.status}`)
      }
      if (values.status == 0) {
        arr.push(`status_id=${values.status}`)
      }

      if (values.project == '' || values.project == undefined) {
      } else {
        arr.push(`searchvalue=${values.project}`)
      }


      window.history.pushState('page2', 'Title', `${arr.join('&')}`)
    }
  }

  const BottomToTop = (props) => {
    return (
      <svg width='40' height='40' viewBox='0 0 40 40' fill='none' className='hover-svg'>
        <rect x='0.5' y='0.5' width='39' height='39' rx='5.5' fill='white' />
        <rect x='0.5' y='0.5' width='39' height='39' rx='5.5' stroke='#074E9F' />
        <path
          d='M23.4685 21.9382H15.5315C15.2934 21.9382 15.1605 22.1896 15.3079 22.3612L19.2764 26.963C19.39 27.0947 19.6088 27.0947 19.7236 26.963L23.6921 22.3612C23.8395 22.1896 23.7066 21.9382 23.4685 21.9382Z'
          fill='#074E9F'
        />
        <path
          d='M23.6921 18.6388L19.7236 14.037C19.61 13.9053 19.3912 13.9053 19.2764 14.037L15.3079 18.6388C15.1605 18.8104 15.2934 19.0617 15.5315 19.0617H23.4685C23.7066 19.0617 23.8395 18.8104 23.6921 18.6388Z'
          fill='#7C7C84'
        />
      </svg>
    )
  }

  const TopToBottom = (props) => {
    return (
      <svg width='40' height='40' viewBox='0 0 40 40' fill='none' className='hover-svg'>
        <rect x='0.5' y='0.5' width='39' height='39' rx='5.5' fill='white' />
        <rect x='0.5' y='0.5' width='39' height='39' rx='5.5' stroke='#074E9F' />
        <path
          d='M23.4685 21.9382H15.5315C15.2934 21.9382 15.1605 22.1896 15.3079 22.3612L19.2764 26.963C19.39 27.0947 19.6088 27.0947 19.7236 26.963L23.6921 22.3612C23.8395 22.1896 23.7066 21.9382 23.4685 21.9382Z'
          fill='#7C7C84'
        />
        <path
          d='M23.6921 18.6388L19.7236 14.037C19.61 13.9053 19.3912 13.9053 19.2764 14.037L15.3079 18.6388C15.1605 18.8104 15.2934 19.0617 15.5315 19.0617H23.4685C23.7066 19.0617 23.8395 18.8104 23.6921 18.6388Z'
          fill='#074E9F'
        />
      </svg>
    )
  }

  const getTitleSortBy = (onSortBy) => {
    switch (onSortBy) {
      case '1':
        return 'Create Date'
      case '2':
        return 'Delayed Day'
      case '3':
        return 'Kickoff Date'
      case '4':
        return 'Plan Closer Date'
      default:
        return 'Project Progress'
    }
  }

  const menu = (
    <Menu
      style={{ width: 200 }}
      onClick={(e) => {
        const mergeData = { ...dataForAction, sortBy: e.key }
        setOnSortBy(e.key)
        onFinish(mergeData)
      }}
      selectedKeys={onSortBy}
    >
      <Menu.Item key='1' style={{ padding: ' 6px 0px 6px 12px' }}>
        Create Date
      </Menu.Item>
      <Menu.Item key='2' style={{ padding: ' 6px 0px 6px 12px' }}>
        Delayed Day
      </Menu.Item>
      <Menu.Item key='3' style={{ padding: ' 6px 0px 6px 12px' }}>
        Kickoff Date
      </Menu.Item>
      <Menu.Item key='4' style={{ padding: ' 6px 0px 6px 12px' }}>
        Plan Closer Date
      </Menu.Item>
      <Menu.Item key='5' style={{ padding: ' 6px 0px 6px 12px' }}>
        Project Progress
      </Menu.Item>
    </Menu>
  )

  const onChangeDate = (date, type) => {
    const dataFormCookie = {
      date:
        [moment(date[0])?.format('YYYY-MM-DD'), moment(date[1])?.format('YYYY-MM-DD')] ||
        null,
      company: 0,
    }
    if (date !== null) {
      if (type === 'main') {
        setDateSearch({
          date: [
            moment(date[0])?.format('YYYY-MM-DD'),
            moment(date[1])?.format('YYYY-MM-DD'),
          ],
        })
        setDataFilter('SearchDate')
      }
    }
    const expirationDate = new Date()
    expirationDate.setFullYear(expirationDate.getFullYear() + 1)
    setDisable((prevState) => ({
      ...prevState,
      company: false,
    }))
  }

  const onChangeSelect = (val, type) => {
    if (type === 'company') {
      getOperation(val)
      selectCompany()
      if (val !== undefined) {
        setDisable((prevState) => ({
          ...prevState,
          operation: false,
        }))
      }
    } else if (type === 'operation') {
      getSubOperation(val)
      selectOperation()
      if (val !== undefined) {
        setDisable((prevState) => ({
          ...prevState,
          suboperation: false,
        }))
      }
    } else if (type === 'sub_operation') {
      selectSubOperation()
      if (val !== undefined) {
        setDisable((prevState) => ({
          ...prevState,
          projectgroup: false,
        }))
      }
    } else if (type === 'project_group') {
      selectProjectGroup()
    } else if (type === 'project_cat') {
      selectProjectCat()
      if (val !== undefined) {
        setDisable((prevState) => ({
          ...prevState,
          impacttype: false,
        }))
      }
    }
  }
  //company
  const selectCompany = () => {
    form.setFieldsValue({
      operation: null,
      sub_opearation: null,
      project_group: null,
      project_cat: null,
      impact_type: null,
    })
    setDisable((prevState) => ({
      ...prevState,
      operation: true,
      suboperation: true,
      projectgroup: true,
      projectcat: true,
      impacttype: true,
    }))
  }
  //operation
  const selectOperation = () => {
    form.setFieldsValue({
      sub_opearation: null,
      project_group: null,
      project_cat: null,
      impact_type: null,
    })
    setDisable((prevState) => ({
      ...prevState,
      suboperation: true,
      projectgroup: true,
      projectcat: true,
      impacttype: true,
    }))
  }
  //Project type
  const selectSubOperation = () => {
    form.setFieldsValue({
      project_group: null,
      project_cat: null,
      impact_type: null,
    })
    setDisable((prevState) => ({
      ...prevState,
      projectgroup: true,
      projectcat: true,
      impacttype: true,
    }))
  }
  //ProjectGroup
  const selectProjectGroup = () => {
    form.setFieldsValue({
      project_cat: null,
      impact_type: null,
    })
    setDisable((prevState) => ({
      ...prevState,
      projectcat: true,
      impacttype: true,
    }))
  }
  //ProjectCategory
  const selectProjectCat = () => {
    form.setFieldsValue({
      impact_type: null,
    })
    setDisable((prevState) => ({
      ...prevState,
      impacttype: true,
    }))
  }

  const onReSetAdvancedFilter = () => {
    setDisable((prevState) => ({
      ...prevState,
      company: false,
      operation: true,
      suboperation: true,
      projectgroup: true,
      projectcat: true,
      impacttype: true,
    })),
      form.resetFields(),
      setChoiceCompany([]),
      setChoiceOperation([]),
      setChoiceSubOperation([]),
      setChoiceProjectGroup([]),
      setChoiceProjectCategory([]),
      setChoiceImpactType([]),
      setChoiceImperative([]),
      setMasterDataProjectCategory([]),
      setMasterDataImperative([]),
      setOnSearch(false),
      setVisible(false),
      setParamDelay('n')

    removeCookie('project_list_filter_For_api'), removeCookie('project_list_filter')
    form.submit()
    window.location.reload()
    return
  }

  const RebaseCutterFunctionally = async (from, valueCom, valueOper, valueSub) => {
    let arrayOperation = []
    let arraySuboperation = []
    if (from === 'from company') {
      masterData.map((p) => {
        if (valueCom.includes(p.value)) {
          p.children?.map((c) => {
            if (valueOper?.includes(c?.value)) {
              arrayOperation.push(c.value)
              c.children?.map((cc) => {
                if (valueSub.includes(cc.value)) {
                  arraySuboperation.push(cc.value)
                }
              })
            }
          })
        }
      })
    } else if (from === 'from operation') {
      arrayOperation = valueOper
      masterData.map((p) => {
        if (valueCom.includes(p.value)) {
          p.children?.map((c) => {
            if (valueOper?.includes(c?.value)) {
              c.children?.map((cc) => {
                if (valueSub.includes(cc.value)) {
                  arraySuboperation.push(cc.value)
                }
              })
            }
          })
        }
      })
    } else {
      arrayOperation = valueOper
      arraySuboperation = valueSub
    }
  }

  let bubbleAdvancedFilter = 0

  const properties = [
    'company',
    'operation',
    'sub_opearation',
    'project_group',
    'subproject_group_id',
    'impact_type',
  ]

  properties.forEach((property) => {
    if (dataCookieToJson?.[property]?.length > 0) {
      bubbleAdvancedFilter++
    }
  })

  if (dataCookieToJson?.date !== undefined) {
    if (dataCookieToJson?.date !== null) {
      bubbleAdvancedFilter++
    }
  }

  // useEffect(() => {
  //   form.setFieldsValue({ ondelay: 'y' })
  // }, [])

  const selectFilter = () => {
    return (
      <Col className='container-select'>
        <Row style={{ alignItems: 'center' }}>
          <ControlOutlined className='controlOutlined' />
          <h3>Advanced Filter</h3>
        </Row>
        <Form.Item name='date' className='size-form'>
          <RangePicker
            onChange={onChangeDate}
            placeholder={['Start kick off date', ' End kick off date']}
            size='large'
            allowClear={false}
          />
        </Form.Item>

        <Form.Item className='disable-page size-form' id='company' name='company'>
          <Company
            RebaseCutterFunctionally={RebaseCutterFunctionally}
            form={form}
            setAccountOptions={setAccountOptions}
            masterData={masterData}
            choiceCompany={choiceCompany}
            choiceOperation={choiceOperation}
            choiceSubOperation={choiceSubOperation}
            setChoiceCompany={setChoiceCompany}
            setChoiceOperation={setChoiceOperation}
            setChoiceSubOperation={setChoiceSubOperation}
            setType={setType}
            setChoiceProjectGroup={setChoiceProjectGroup}
            setChoiceProjectCategory={setChoiceProjectCategory}
            setChoiceImpactType={setChoiceImpactType}
          />
        </Form.Item>

        <Form.Item className='size-form' id='operation' name='operation'>
          <TreeSelectOperation
            RebaseCutterFunctionally={RebaseCutterFunctionally}
            form={form}
            setAccountOptions={setAccountOptions}
            masterData={masterData}
            choiceCompany={choiceCompany}
            choiceOperation={choiceOperation}
            choiceSubOperation={choiceSubOperation}
            setChoiceOperation={setChoiceOperation}
            setChoiceSubOperation={setChoiceSubOperation}
            setType={setType}
          />
        </Form.Item>

        <Form.Item className='size-form' id='sub_operation' name='sub_opearation'>
          <TreeSelectSubOperation
            RebaseCutterFunctionally={RebaseCutterFunctionally}
            form={form}
            setAccountOptions={setAccountOptions}
            masterData={masterData}
            choiceCompany={choiceCompany}
            choiceOperation={choiceOperation}
            choiceSubOperation={choiceSubOperation}
            setChoiceSubOperation={setChoiceSubOperation}
            setType={setType}
          />
        </Form.Item>

        <Form.Item className='size-form' id='project_group' name='project_group'>
          <Select
            mode='multiple'
            size='large'
            placeholder='Select Strategic Perspective'
            disabled={isEmpty(choiceCompany)}
            value={choiceProjectGroup}
            onChange={(val) => {
              setChoiceProjectGroup(val)
              setChoiceProjectCategory([])
              setChoiceImperative([])
            }}
            maxTagCount={1}
            options={masterDataProjectGroup.map((g) => ({
              value: g.id,
              label: g.name_en || g.name,
            }))}
            filterOption={(input, option) =>
              (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
            }
            allowClear
            style={{ width: '100%' }}
          />
        </Form.Item>

        <Form.Item className='size-form' id='project_cat' name='project_cat'>
          <Select
            mode='multiple'
            size='large'
            placeholder='Select Strategic Direction'
            disabled={isEmpty(choiceProjectGroup)}
            value={choiceProjectCategory}
            onChange={(val) => {
              setChoiceProjectCategory(val)
              setChoiceImperative([])
            }}
            maxTagCount={1}
            options={masterDataProjectCategory.map((c) => ({
              value: c.id,
              label: c.name_en || c.name,
            }))}
            filterOption={(input, option) =>
              (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
            }
            allowClear
            style={{ width: '100%' }}
          />
        </Form.Item>

        <Form.Item className='size-form' id='imperative' name='imperative'>
          <Select
            mode='multiple'
            size='large'
            placeholder='Select Imperative'
            disabled={isEmpty(choiceProjectCategory)}
            value={choiceImperative}
            onChange={(val) => setChoiceImperative(val)}
            maxTagCount={1}
            options={masterDataImperative.map((i) => ({
              value: i.id,
              label: i.name_en || i.name,
            }))}
            filterOption={(input, option) =>
              (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
            }
            allowClear
            style={{ width: '100%' }}
          />
        </Form.Item>

        <Form.Item className='size-form' id='impact_type' name='impact_type'>
          <Select
            mode='multiple'
            size='large'
            placeholder='Select Impact Type'
            disabled={isEmpty(choiceCompany)}
            value={choiceImpactType}
            onChange={(val) => setChoiceImpactType(val)}
            maxTagCount={1}
            options={masterDataImpactType.map((i) => ({
              value: i.id,
              label: i.name_en || i.name,
            }))}
            filterOption={(input, option) =>
              (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
            }
            allowClear
            style={{ width: '100%' }}
          />
        </Form.Item>
        <Row className='footer-filter'>
          <Button
            className='BTN_Previous'
            // htmlType='submit'
            onClick={() => {
              onReSetAdvancedFilter()
            }}
          >
            Reset
          </Button>
          <Button
            icon={<SearchOutlined className='searchOutlined' />}
            className='BTN_Next'
            onClick={() => {
              const dataFormCookie = {
                date:
                  form.getFieldValue('date') === undefined ||
                    form.getFieldValue('date') === null
                    ? null
                    : [
                      moment(form.getFieldValue('date')[0]).format('YYYY-MM-DD'),
                      moment(form.getFieldValue('date')[1]).format('YYYY-MM-DD'),
                    ],
                company: form.getFieldValue('company'),
                impact_type: form.getFieldValue('impact_type'),
                operation: form.getFieldValue('operation'),
                project_cat: form.getFieldValue('project_cat'),
                project_group: form.getFieldValue('project_group'),
                sub_opearation: form.getFieldValue('sub_opearation'),
              }
              form.submit()
              const expirationDate = new Date()
              expirationDate.setFullYear(expirationDate.getFullYear() + 1)
              setCookie('project_list_filter', dataFormCookie, {
                expires: expirationDate,
              })
              setVisible(false)
            }}
          >
            Search
          </Button>
        </Row>
      </Col>
    )
  }

  const onSearchList = () => {
    onDataReceived(paramDelay)
  }

  const onSelectStatus = (isValue) => {
    if (isValue === 0) {
      const allStatus = statusDataListFromApi.map((c) => c.value)
      setListStatusWhenCheang(allStatus)
    } else if (listStatusWhenCheang?.length + 1 === totalListStatusFromApi) {
      setListStatusWhenCheang((prev) => [0, ...prev, isValue])
    } else {
      setListStatusWhenCheang((prev) => {
        if (Array.isArray(prev)) {
          return [...prev, isValue]
        } else {
          return [isValue]
        }
      })
    }
  }

  const onDeselectStatus = (isValue) => {
    if (isValue === 0) {
      setListStatusWhenCheang([])
    } else {
      const handleDeselect = listStatusWhenCheang.filter((f) => f !== isValue)
      const filterZero = handleDeselect.filter((f) => f !== 0)
      setListStatusWhenCheang(filterZero)
    }
  }

  const handleTreeSelectStatus = (event) => {
    if (event === 'ok') {
      setOpenTreeStatus(false)
    }
    if (event === 'cancel') {
      setListStatusWhenCheang(listStatusWhenCheang)
      setOpenTreeStatus(false)
    }
    return true
  }
  useEffect(() => {
    form.setFieldsValue({ status: listStatusWhenCheang })
  }, [listStatusWhenCheang])

  return (
    <>
      <Form form={form} onFinish={onFinish}>
        <Row className='header-content'>
          <div className='group-search-one'>
            <div className='layout-a'>
              <Tooltip
                placement='bottom'
                title={'Project,Description,Project id,Member or Short Business'}
              >
                <Form.Item name='project'>
                  <Input
                    size='large'
                    placeholder='Project,Description,Project id,Member or Short Business'
                    allowClear
                  />
                </Form.Item>
              </Tooltip>
            </div>
            <div className='layout-b'>
              <Form.Item name='status'>
                <TreeSelect
                  onClear={() => setListStatusWhenCheang([])}
                  allowClear
                  showSearch
                  filterTreeNode={(search, item) => {
                    return item.title.toLowerCase().indexOf(search.toLowerCase()) >= 0
                  }}
                  id='country-treeselect'
                  open={openTreeStatus}
                  size='large'
                  maxTagCount={1}
                  onDropdownVisibleChange={(e) => {
                    if (e) {
                      setOpenTreeStatus(e)
                    } else {
                      handleTreeSelectStatus('cancel')
                    }
                  }}
                  treeCheckable
                  value={listStatusWhenCheang}
                  showCheckedStrategy='SHOW_PARENT'
                  onSelect={onSelectStatus}
                  onDeselect={onDeselectStatus}
                  placeholder={'Select Status'}
                  maxTagPlaceholder={(event) => {
                    const find = listStatusWhenCheang?.find((fi) => fi === 0)
                    return (
                      <span
                        style={{
                          display: find !== undefined ? 'none' : '',
                        }}
                      >
                        {<>and {event?.length} other status</>}
                      </span>
                    )
                  }}
                  dropdownRender={(option) => {
                    return <>{option}</>
                  }}
                  tagRender={(event) => {
                    const { value, label } = event
                    const find = listStatusWhenCheang?.find((fi) => fi === 0)
                    if (value === 0) {
                      return (
                        <span
                          id={`tag-${label}`}
                          style={{ paddingLeft: 8, fontSize: 16 }}
                        >
                          {'All'}
                        </span>
                      )
                    }
                    return (
                      <Tag
                        style={{
                          display: find === 0 && value !== 0 ? 'none' : 'flex',
                          fontSize: 12,
                          borderRadius: '16px',
                          background: 'rgba(7, 78, 159, 0.1)',
                          height: '32px',
                          alignItems: 'center',
                          color: '#074E9F',
                        }}
                      >
                        {label}
                      </Tag>
                    )
                  }}
                  treeData={statusDataListFromApi}
                />
              </Form.Item>
            </div>
            <div className='layout-c'>
              <Form.Item name='ondelay'>
                <Checkbox.Group>
                  <Checkbox value='y' onClick={(a) => setIsChecked(a.target.checked)}>
                    Delay
                  </Checkbox>
                </Checkbox.Group>
              </Form.Item>
            </div>
            <div className='layout-d'>
              <Button
                id='btn_search'
                htmlType='submit'
                className='BTN_Next'
                style={{ width: '100%' }}
                disabled={visible}
                onClick={() => {
                  onSearchList()
                  // onFinish()
                  setOnSearch(false)
                }}
              >
                <SearchOutlined className='Icon-color' />
                {word['Search']}
              </Button>
            </div>
            <div className='layout-e'>
              <Button
                id='btn_createProject'
                className='BTN_Next'
                hidden={permission.create ? false : true}
                disabled={company_user < 1 || company_user === '' ? true : false}
                onClick={goCreate}
                style={{ width: '100%' }}
              >
                <PlusOutlined className='Icon-color' />
                {word['Create_Project']}
              </Button>
            </div>
          </div>
          <div className='search-two'>
            {/* advanced filter */}
            <Popover
              arrowContent={true}
              content={selectFilter()}
              trigger='click'
              visible={visible}
              placement='bottomRight'
            >
              <Button
                id='advanceFilter'
                className='mini-search-btn-admin-reset'
                onClick={() => !isShowAdvanFilter && setVisible(!visible)}
                style={{ minWidth: isMobielView ? '95vw' : 'unset', height: '40px' }}
              >
                {isShowAdvanFilter ? (
                  <Spin style={{ marginTop: '5px' }} />
                ) : (
                  <div className='advenced-filter'>
                    {bubbleAdvancedFilter !== 0 && (
                      <div className='bubble-position'>{bubbleAdvancedFilter}</div>
                    )}
                    <ControlOutlined style={{ color: '#074E9F', fontSize: '20px' }} />
                    <p>Advanced Filter</p>
                  </div>
                )}
              </Button>
            </Popover>
            {/* Sort By */}
            {isMobielView ? (
              <div className='mode-moble-sort-by'>
                <Dropdown overlay={menu}>
                  <Button
                    style={{ height: '40px' }}
                    className='mini-search-btn-admin-reset'
                  >
                    <Row style={{ marginLeft: '7px', justifyContent: 'center' }}>
                      {`Sort By : ${getTitleSortBy(onSortBy)}`}
                      <div
                        style={{
                          marginTop: '2px',
                          marginLeft: '9px',
                          marginRight: '8px',
                        }}
                      >
                        <DownOutlined style={{ fontSize: '17px', color: '#074E9F' }} />
                      </div>
                    </Row>
                  </Button>
                </Dropdown>

                <Tooltip
                  placement='topRight'
                  title={!onSortTopOrButtom ? 'Ascending Order' : 'Descending Order'}
                >
                  <div
                    onClick={() => {
                      const mergeData = { ...dataForAction, toTop: !onSortTopOrButtom }
                      setOnSortTopOrButtom(!onSortTopOrButtom)
                      onFinish(mergeData)
                    }}
                  // style={{ width: isMobielView && '40px' }}
                  >
                    {!onSortTopOrButtom ? <TopToBottom /> : <BottomToTop />}
                  </div>{' '}
                </Tooltip>
              </div>
            ) : (
              <>
                <Dropdown overlay={menu}>
                  <Button
                    style={{ height: '40px' }}
                    className='mini-search-btn-admin-reset'
                  >
                    <Row style={{ marginLeft: '7px', justifyContent: 'center' }}>
                      {`Sort By : ${getTitleSortBy(onSortBy)}`}
                      <div
                        style={{
                          marginTop: '2px',
                          marginLeft: '9px',
                          marginRight: '8px',
                        }}
                      >
                        <DownOutlined style={{ fontSize: '17px', color: '#074E9F' }} />
                      </div>
                    </Row>
                  </Button>
                </Dropdown>

                <Tooltip
                  placement='topRight'
                  title={!onSortTopOrButtom ? 'Ascending Order' : 'Descending Order'}
                >
                  <div
                    onClick={() => {
                      const mergeData = { ...dataForAction, toTop: !onSortTopOrButtom }
                      setOnSortTopOrButtom(!onSortTopOrButtom)
                      onFinish(mergeData)
                    }}
                    style={{ width: isMobielView && '40px' }}
                  >
                    {!onSortTopOrButtom ? <TopToBottom /> : <BottomToTop />}
                  </div>{' '}
                </Tooltip>
              </>
            )}
          </div>
        </Row>
      </Form>
    </>
  )
}

export default HeaderContent
